<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col>
                <v-card
                    width="70"
                    flat
                    class="d-flex flex-column align-center grey lighten-5"
                    v-show="mainMenuButton"
                >
                    <v-expand-transition>
                        <v-btn
                            color="primary"
                            dark
                            fab
                            small
                            @click="showMainMenu"
                        >
                            <v-icon>
                                mdi-arrow-left
                            </v-icon>

                        </v-btn>
                    </v-expand-transition>
                    <div
                        class="caption mt-2"
                    >
                        Main Menu
                    </div>
                </v-card>
            </v-col>

            <v-col>
                <v-card width="70vw">
                    <v-toolbar
                        flat
                        color="primary"
                        dark
                    >
                        <v-toolbar-title>CSEC Subject Selection</v-toolbar-title>
                    </v-toolbar>

                    <v-card-title>
                        <v-spacer></v-spacer>
                         <v-btn
                            color="primary"
                            class="mr-4"
                            dark
                            @click="noApplicationReport"
                        >
                            <div class="d-flex flex-column" style="font-size:0.7rem">
                                <span>Students</span>
                                <span>Without Application</span>
                            </div>
                        </v-btn>

                         <v-btn
                            color="primary"
                            class="mr-3"
                            dark
                            @click="downloadAllApplications"
                        >
                            <v-icon
                                left
                            >
                                mdi-download
                            </v-icon>
                            <div class="d-flex flex-column" style="font-size:0.7rem">
                                <span>1st Choice</span>
                                <span>Selection Spreadsheet</span>
                            </div>
                        </v-btn>
                    </v-card-title>

                    <v-card-text class="mt-0">
                       <v-data-table
                            :headers="headers"
                            :items="applications"
                            :loading="loading"
                            height="45vh"
                            fixed-header
                            :search="search"
                       >

                            <template v-slot:top>
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Search Application"
                                    single-line
                                    hide-details
                                    clearable
                                    class="mx-4 mb-8"
                                ></v-text-field>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-btn
                                    @click="viewApplication(item)"
                                    x-small
                                    color="primary"
                                    class="mr-4"
                                >
                                    View Application
                                </v-btn>
                                <v-btn
                                    @click="editSelection(item)"
                                    x-small
                                    color="primary"
                                >
                                    Edit Selection
                                </v-btn>
                           </template>
                       </v-data-table>
                    </v-card-text>

                    <v-card-actions class="px-4">
                        <v-spacer></v-spacer>

                    </v-card-actions>

                    <v-overlay
                        :value="overlay"
                        absolute
                    >
                        <v-progress-circular
                            indeterminate
                            size="64"
                        ></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-col>
            <v-col></v-col>
        </v-row>

        <v-dialog
            v-model="dialog"
            width="60vw"
            persistent
        >
            <v-card v-if="dialog">
                <v-card-text class="px-0 pb-2">
                    <v-card height="80vh">
                        <iframe
                            ref="pdf"
                            style="width:100%; height:100%"
                            frameBorder="0"
                            :src="src"
                            @load="pdfLoaded"
                        ></iframe>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="dialog = false"
                    >
                        Close Report
                    </v-btn>
                </v-card-actions>

                <v-overlay
                    :value="overlayReport"
                    color="white"
                    absolute
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>


            </v-card>


        </v-dialog>

        <v-dialog
            v-model="dialogEditSelection"
            width="40vw"
            persistent
        >
            <v-card>
                <v-card-title>{{ cardTitle }}</v-card-title>
                <v-card-subtitle class="pt-1">{{ cardSubtitle }}</v-card-subtitle>

                <v-card-text>
                    <v-alert
                        v-if="alert.display"
                        dense
                        text
                        :type="alert.type"
                    >
                        {{ alert.text }}
                    </v-alert>

                    <div v-for="choice in choices" :key="choice.id" class="mb-10">
                        <v-select
                            v-model="choice.formClass"
                            outlined
                            hide-details=""
                            label="Form Class"
                            placeholder=" "
                            :items="formClasses"
                            class="mb-4"
                            dense
                            @change="updateClassSubjectChoice(choice.id)"
                        ></v-select>

                        <v-data-table
                            :headers="headersSubjectChoice"
                            :items="choice.subjectLines"
                            hide-default-footer
                            hide-default-header
                            :loading="loadingSubjectChoices"
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>
                                        {{ item.line }}
                                    </td>
                                    <td>
                                        <v-select
                                            v-model="subjectsChosen[choice.id][item.line]"
                                            outlined
                                            dense
                                            hide-details
                                            placeholder="Subject"
                                            :items="item.subjects"
                                            item-text="title"
                                            item-value="subject_id"
                                            @change="updateLineSubjectChoice(choice.id, item.line)"
                                        >
                                            <template v-slot:append-outer>
                                                <v-fade-transition>
                                                    <v-progress-circular
                                                        v-if="item.saveStatus.saving"
                                                        size="16"
                                                        width="3"
                                                        color="info"
                                                        indeterminate
                                                    ></v-progress-circular>
                                                </v-fade-transition>

                                                <v-fade-transition>
                                                    <v-icon
                                                        v-if="item.saveStatus.saveSuccess"
                                                        small
                                                        color="info"
                                                    >
                                                        mdi-check-all
                                                    </v-icon>
                                                </v-fade-transition>

                                                <v-fade-transition>
                                                    <v-icon
                                                        v-if="item.saveStatus.saveError"
                                                        small
                                                        color="red"
                                                    >
                                                        mdi-alert-circle
                                                    </v-icon>
                                                </v-fade-transition>
                                            </template>
                                        </v-select>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>    
                </v-card-text>

                <v-overlay
                    :value="overlayEditSelection"
                    absolute
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>

                <v-card-actions class="pr-4">
                    <v-spacer></v-spacer>
                    <v-btn
                        depressed
                        @click="dialogEditSelection = false"
                        class="mr4"
                    >
                        Close
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="updateSelection"
                    >
                        Update
                    </v-btn>
                </v-card-actions>
            </v-card>


        </v-dialog>



    </v-container>
</template>


<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    data: function () {
        return {
            reportSelected: null,
            showClasses: false,
            classSelected: null,
            overlay: false,
            reportTitle: null,
            src: null,
            dialog: false,
            overlayReport: false,
            headers: [
                { text: '#', value: 'row_number', width: '80'},
                { text: 'Student ID', value: 'student_id', width: '120'},
                { text: 'Student Name', value: 'name'},
                { text: 'Current Class', value: 'class_id', width: '150'},
                { text: 'Actions', value: 'actions'},
            ],
            applications: [],
            loading: false,
            search: '',
            dialogEditSelection: false,
            cardTitle: null,
            assignedFormClass: null,
            headersSubjectChoice: [
                {text: ''},
                {text: ''},
            ],
            subjectLines: [],
            formClasses: ['4-1', '4-2', '4-3', '4-4', '4-5', '4-6', '4-7'],
            loadingSubjectChoices: false,
            subjectsChosen:[],
            choices: [
                {id: 1, name: '1st Choice', formClass: null, subjectLines: []},
            ],
            selectedItem: null,
            overlayEditSelection: false,
            cardSubtitle: null,
            alert: {
                type: null,
                text: null,
                display: false
            }
        }
    },

    watch: {
        //
    },

    created () {
        this.initialize();
    },

    computed: {
        ...mapGetters({
            mainMenuButton: 'termReports/getMainMenuButton',
        })
    },

    methods: {
        ...mapMutations({
            setPrintViewReports: 'termReports/setPrintViewReports',
            setMainMenu: 'termReports/setMainMenu',
            setWelcomeMessage: 'termReports/setWelcomeMessage',
            setClassSelected: 'printViewReports/setClassSelected',
            setCsecSubjectSelection: 'termReports/setCsecSubjectSelection',
            setStudentId: 'csecSubjectSelection/setStudentId',
            setLineSubjectChosen: 'csecSubjectSelection/setLineSubjectChosen',
        }),

        ...mapActions({
            getCsecSubjectApplications: 'csecSubjectSelection/getCsecSubjectApplications',
            downloadApplications: 'csecSubjectSelection/downloadApplications',
            getCsecSubjectSelectionLines: 'csecSubjectSelection/getCsecSubjectSelectionLines',
            postSubjectSelectionLine: 'csecSubjectSelection/postSubjectSelectionLine',
            getSubjectChoice: 'csecSubjectSelection/getSubjectChoice',

        }),

        async initialize(){
            this.loading = true;
            try {
                const { data } = await this.getCsecSubjectApplications();
                this.applications = data;

            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }

            this.loading = false;
        },

        showMainMenu(){
            this.setPrintViewReports(false);
            this.setWelcomeMessage(true);
            this.setMainMenu(true);
            this.setCsecSubjectSelection(false);
        },

        viewApplication(item){
            this.src = `${process.env.VUE_APP_API_URI}/api/csec-subject-selection-form?student_id=${item.student_id}`
            this.overlayReport = true;
            this.dialog= true;
        },


        pdfLoaded (){
            this.overlayReport = false;
        },

        downloadAllApplications () {
            this.overlay = true;
            console.log("download all applications..")
            this.downloadApplications()
            .then(response => {
                console.log(response);
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                link.setAttribute('download', '2026 CSEC Subject Selection.xlsx');
                document.body.appendChild(link);
                link.click();
            })
            .catch( error => {
                if(error.response) console.log(error.response);
                else console.log(error);

            })
            .finally(() => this.overlay = false);
            // this.overlay = false;
        },

        noApplicationReport () {
            this.src = `${process.env.VUE_APP_API_URI}/api/csec-subject-no-applications`
            this.overlayReport = true;
            this.dialog= true;
        },

        async editSelection(item){
            this.dialogEditSelection = true;
            this.overlayEditSelection = true;
            this.cardTitle = item.name;
            this.cardSubtitle = `Student ID: ${item.student_id}`
            this.setStudentId(item.student_id);
            this.selectedItem = item;

            for(let i = 1; i <= 4; i++){
                this.subjectsChosen[i] = [Array(7).fill(null)];
            }

            try {
                const[
                    { data: dataCsecSubjectSelectionLines },
                    { data: dataSubjectChoice}
                ] = await Promise.all([
                    this.getCsecSubjectSelectionLines(),
                    this.getSubjectChoice(),
                ])
                this.subjectLines = dataCsecSubjectSelectionLines;
                this.mapSubjectChoicesLines(dataCsecSubjectSelectionLines);
                this.mapSelectedSubjectChoices(dataSubjectChoice);
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            } finally {
                this.overlayEditSelection = false;
            }
        },

         mapSelectedSubjectChoices(data){
            data.forEach(item => {
                let choice = this.choices.find(choice => choice.id === item.choice)
                if(!choice) return;
                choice.formClass = item.form_class_id

                this.updateClassSubjectChoice(choice.id);
                switch(item.choice){
                    case 1: this.subjectsChosen[1][item.line] = item.subject_id; break;
                    case 2: this.subjectsChosen[2][item.line] = item.subject_id; break;
                    case 3: this.subjectsChosen[3][item.line] = item.subject_id; break;
                    case 4: this.subjectsChosen[4][item.line] = item.subject_id; break;
                }

            })
        },

        mapSubjectChoicesLines(data){
            const lines = [...new Set(data.map(item => item.line))];

            this.choices.forEach(choice => choice.subjectLines = lines.map(line => ({
                line: line,
                subjects: [],
                saveStatus: {
                    saving: false,
                    saveSuccess: false,
                    saveError: false,
                },
                disabled: true,
            })));

        },

        updateClassSubjectChoice(choice){
            let classChoice = this.choices.find(item => item.id === choice);
            let subjectLines = this.subjectLines.filter(item => item.form_class_id === classChoice.formClass);
            classChoice.subjectLines.forEach(item => {
                item.subjects = subjectLines.filter(line => line.line === item.line)
                item.disabled = false;
                if(item.subjects.length === 0) item.disabled = true;
                if(item.subjects.length === 1){
                    item.disabled = true;
                    this.subjectsChosen[choice][item.line] = item.subjects[0].subject_id
                    this.updateLineSubjectChoice(choice, item.line);
                }

            });
        },

        async updateLineSubjectChoice(choice, line){
            this.setLineSubjectChosen({
                choice, 
                line, 
                subject_id: this.subjectsChosen[choice][line],
                form_class_id: this.choices.find(item => item.id === choice).formClass,
                student_id: this.selectedItem.student_id
            });
            try {
                await this.postSubjectSelectionLine();
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
        },

        async updateSelection() {
            this.overlayEditSelection = true;
            this.alert.display = false;
            console.log('subjectsChosen', this.subjectsChosen);
            try {
                await Promise.all(
                    this.subjectsChosen[1].map((item, index) =>
                        this.updateLineSubjectChoice(1, index + 1)
                    )
                );

                this.alert.type = 'success';
                this.alert.text = 'Selection updated successfully.';
            } catch (error) {
                this.alert.type = 'error';
                this.alert.text = 'Selection not updated. An error occurred.';
            } finally {
                this.overlayEditSelection = false;
                this.alert.display = true;
            }
        }
    }
}
</script>